import { render, staticRenderFns } from "./SelectorAsientoComponent.vue?vue&type=template&id=40b6ee10&scoped=true"
import script from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
export * from "./SelectorAsientoComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectorAsientoComponent.vue?vue&type=style&index=0&id=40b6ee10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6ee10",
  null
  
)

export default component.exports